import { styled } from '../../config'

/**
 * Simple div that accepts additional props as any other styled component
 */
export const Box = styled('div', {
  variants: {
    row: { true: { display: 'flex', flexDirection: 'row' } },
    column: { true: { display: 'flex', flexDirection: 'column' } },
    wrap: { true: { flexWrap: 'wrap' } },
    alignStart: { true: { alignItems: 'start' } },
    alignCenter: { true: { alignItems: 'center' } },
    alignEnd: { true: { alignItems: 'end' } },
    alignStretch: { true: { alignItems: 'stretch' } },
    justifyStart: { true: { justifyContent: 'start' } },
    justifyEnd: { true: { justifyContent: 'end' } },
    justifyCenter: { true: { justifyContent: 'center' } },
    justifyBetween: { true: { justifyContent: 'space-between' } },
    justifyAround: { true: { justifyContent: 'space-around' } },
    width: { full: { width: '100%' } },
    height: { fit: { height: 'fit-content' }, full: { height: '100%' } },
    minWidth: {
      0: { minWidth: 0 }
    },
    gap: {
      0: { gap: '0px' },
      2: { gap: '2px' },
      4: { gap: '4px' },
      8: { gap: '8px' },
      12: { gap: '12px' },
      16: { gap: '16px' },
      20: { gap: '20px' },
      24: { gap: '24px' },
      32: { gap: '32px' }
    },
    mb: {
      0: { marginBottom: '0px' },
      4: { marginBottom: '4px' },
      8: { marginBottom: '8px' },
      12: { marginBottom: '12px' },
      16: { marginBottom: '16px' },
      20: { marginBottom: '20px' },
      24: { marginBottom: '24px' },
      32: { marginBottom: '32px' }
    },
    mt: {
      0: { marginTop: '0px' },
      4: { marginTop: '4px' },
      8: { marginTop: '8px' },
      12: { marginTop: '12px' },
      16: { marginTop: '16px' },
      20: { marginTop: '20px' },
      24: { marginTop: '24px' },
      32: { marginTop: '32px' }
    },
    mx: {
      0: { marginLeft: '0px', marginRight: '0px' },
      4: { marginLeft: '4px', marginRight: '4px' },
      8: { marginLeft: '8px', marginRight: '8px' },
      12: { marginLeft: '12px', marginRight: '12px' },
      16: { marginLeft: '16px', marginRight: '16px' },
      20: { marginLeft: '20px', marginRight: '20px' },
      24: { marginLeft: '24px', marginRight: '24px' },
      32: { marginLeft: '32px', marginRight: '32px' }
    },
    my: {
      0: { marginTop: '0px', marginBottom: '0px' },
      4: { marginTop: '4px', marginBottom: '4px' },
      8: { marginTop: '8px', marginBottom: '8px' },
      12: { marginTop: '12px', marginBottom: '12px' },
      16: { marginTop: '16px', marginBottom: '16px' },
      20: { marginTop: '20px', marginBottom: '20px' },
      24: { marginTop: '24px', marginBottom: '24px' },
      32: { marginTop: '32px', marginBottom: '32px' }
    },
    ml: {
      0: { marginLeft: '0px' },
      4: { marginLeft: '4px' },
      8: { marginLeft: '8px' },
      12: { marginLeft: '12px' },
      16: { marginLeft: '16px' },
      20: { marginLeft: '20px' },
      24: { marginLeft: '24px' },
      32: { marginLeft: '32px' }
    },
    mr: {
      0: { marginRight: '0px' },
      4: { marginRight: '4px' },
      8: { marginRight: '8px' },
      12: { marginRight: '12px' },
      16: { marginRight: '16px' },
      20: { marginRight: '20px' },
      24: { marginRight: '24px' },
      32: { marginRight: '32px' }
    },
    pt: {
      0: { paddingTop: '0px' },
      4: { paddingTop: '4px' },
      8: { paddingTop: '8px' },
      12: { paddingTop: '12px' },
      16: { paddingTop: '16px' },
      20: { paddingTop: '20px' },
      24: { paddingTop: '24px' },
      32: { paddingTop: '32px' }
    },
    pb: {
      0: { paddingBottom: '0px' },
      4: { paddingBottom: '4px' },
      8: { paddingBottom: '8px' },
      12: { paddingBottom: '12px' },
      16: { paddingBottom: '16px' },
      20: { paddingBottom: '20px' },
      24: { paddingBottom: '24px' },
      32: { paddingBottom: '32px' }
    },
    px: {
      0: { paddingLeft: '0px', paddingRight: '0px' },
      4: { paddingLeft: '4px', paddingRight: '4px' },
      8: { paddingLeft: '8px', paddingRight: '8px' },
      12: { paddingLeft: '12px', paddingRight: '12px' },
      16: { paddingLeft: '16px', paddingRight: '16px' },
      20: { paddingLeft: '20px', paddingRight: '20px' },
      24: { paddingLeft: '24px', paddingRight: '24px' },
      32: { paddingLeft: '32px', paddingRight: '32px' }
    },
    py: {
      0: { paddingTop: '0px', paddingBottom: '0px' },
      4: { paddingTop: '4px', paddingBottom: '4px' },
      8: { paddingTop: '8px', paddingBottom: '8px' },
      12: { paddingTop: '12px', paddingBottom: '12px' },
      16: { paddingTop: '16px', paddingBottom: '16px' },
      20: { paddingTop: '20px', paddingBottom: '20px' },
      24: { paddingTop: '24px', paddingBottom: '24px' },
      32: { paddingTop: '32px', paddingBottom: '32px' }
    },
    p: {
      0: { padding: '0px' },
      4: { padding: '4px' },
      8: { padding: '8px' },
      12: { padding: '12px' },
      16: { padding: '16px' },
      20: { padding: '20px' },
      24: { padding: '24px' },
      32: { padding: '32px' }
    },
    m: {
      0: { margin: '0px' },
      4: { margin: '4px' },
      8: { margin: '8px' },
      12: { margin: '12px' },
      16: { margin: '16px' },
      20: { margin: '20px' },
      24: { margin: '24px' },
      32: { margin: '32px' }
    },
    flex: {
      1: { flex: 1 },
      2: { flex: 2 },
      3: { flex: 3 }
    },
    shrink: {
      0: { flexShrink: 0 }
    },
    flexGrow: {
      1: { flexGrow: 1 }
    }
  }
})
